
import "primereact/resources/themes/lara-light-indigo/theme.css"; // podés cambiar de theme
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./index.css";
import MitoTrasladosScreen from "./screens/MitoTrasladosScreen"
//import MitoDespachoScreen from "../../ambulance2025/src/components/layout/listados/MitoDespachoScreen";

export default function App() {
  return <MitoTrasladosScreen />;
}

